import React from "react";
import ProductDetails from "../../../../components/productDetail/productDetail";
import { SEO } from "../../../../components/seo";

const DetailPage = ({ location }) => {
  return <ProductDetails pageContext={{}} location={location} />;
};

export default DetailPage;

export const Head = ({ location, pageContext }) => (
  <SEO
    canonical={`https://www.salvex.com${location.pathname}`}
    title={"Listing Detail | Salvex"}
    description={"Listing Detail | Salvex"}
    image={"https://media.salvex.com/auction/p/1830079/183007825_698229_lp.jpg"}
    article="website"
    noIndex={true}
  />
);
